// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1nQdJ","name":"ConsentHeader_name__1Be-0","birthday":"ConsentHeader_birthday__2Wa_b","skeleton":"ConsentHeader_skeleton__3RdN5"};